<template>
  <div id="app">
    <Head></Head>
    <div class="banner">
      <img
        v-if="this.$store.state.currentLang === 'zh'"
        :src="this.$path + '/assets/images/banner-cloud-zh.png'"
        :alt="$t('langs.aolei')"
      />
      <img
        v-if="this.$store.state.currentLang === 'en'"
        :src="this.$path + '/assets/images/banner-cloud-en.png'"
        :alt="$t('langs.aolei')"
      />
    </div>
    <div class="cloud_center" style="margin-top: 20px">
      <div class="main_cloud_context">
        <img :src="this.$path + '/assets/images/main-cloud.png'" />
        <span>
          <div class="title_cloud_context">
            <div class="title_cloud_name">
              {{ $t("langs.cloudplatform") }}
            </div>
            <em class="green"></em>
            <em class="gray"></em>
          </div>
          <div class="cloud_botton_context">
            <div class="cloud_span_line">
              <div class="botton_cloud_circle"></div>
              <div class="info_cloud_botton_text">
                {{ $t("langs.platformone") }}
              </div>
            </div>
            <div class="cloud_span_line">
              <div class="botton_cloud_circle"></div>
              <div class="info_cloud_botton_text">
                {{ $t("langs.platformtwo") }}
              </div>
            </div>
            <div class="cloud_span_line">
              <div class="botton_cloud_circle"></div>
              <div class="info_cloud_botton_text">
                {{ $t("langs.platformthree") }}
              </div>
            </div>
            <div class="cloud_span_line">
              <div class="botton_cloud_circle"></div>
              <div class="info_cloud_botton_text">
                {{ $t("langs.platformfour") }}
              </div>
            </div>
          </div>
        </span>
      </div>
    </div>
    <div class="box_center_pd">
      <span class="text_pd">{{ $t("langs.features") }}</span>
    </div>
    <div class="row_line">
      <span class="td_line" style="margin-bottom: 20px"></span>
    </div>
    <div class="cloud_center">
      <img
        class="main_block_img"
        :src="this.$path + '/assets/images/features_cloud_one.png'"
      />
      <img
        class="main_block_img"
        :src="this.$path + '/assets/images/features_cloud_two.png'"
      />
    </div>
    <div class="cloud_center">
      <div class="cloud_main_title">{{ $t("langs.cloudtextone") }}</div>
      <div class="cloud_main_title">{{ $t("langs.cloudtexttwo") }}</div>
    </div>
    <div class="cloud_center">
      <div class="main_block_div">
        {{ $t("langs.cloudmemoone") }}
      </div>
      <div class="main_block_div">
        {{ $t("langs.cloudmemotwo") }}
      </div>
    </div>
    <div class="cloud_center">
      <img
        class="main_block_img"
        :src="this.$path + '/assets/images/features_cloud_three.png'"
      />
      <img
        class="main_block_img"
        :src="this.$path + '/assets/images/features_cloud_four.png'"
      />
    </div>
    <div class="cloud_center">
      <div class="cloud_main_title">{{ $t("langs.cloudtextthree") }}</div>
      <div class="cloud_main_title">{{ $t("langs.cloudtextfour") }}</div>
    </div>
    <div class="cloud_center">
      <div class="main_block_div">
        {{ $t("langs.cloudmemothree") }}
      </div>
      <div class="main_block_div">
        {{ $t("langs.cloudmemofour") }}
      </div>
    </div>
    <Footer></Footer>
    <Hover></Hover>
  </div>
</template>

<script>
import Head from "../components/head/head.vue";
import Footer from "../components/footer/footer.vue";
import Hover from '../components/hover';

export default {
  name: "centercloud",
  components: { Head, Footer,Hover },
};
</script>

<style scoped>
@import "../assets/css/center.css";

.cloud_center {
  width: auto;
  display: flex;
  padding: 10px 10%;
  justify-items: center;
  justify-content: center;
  font-size: 16px;
  color: #666666;
  line-height: 24px;
}

.cloud_botton_context {
  display: block;
  width: 100%;
  text-align: left;
  height: 230px;
  padding-left: 10%;
}

.cloud_span_line {
  width: 90%;
  height: 28px;
  margin: 10px 5px;
  font-size: 20px;
  font-weight: 400;
  display: inline-block;
  text-align: left;
}

.botton_cloud_circle {
  width: 8px !important;
  height: 8px !important;
  display: block;
  background-color: #00d265;
  border-radius: 50%;
  margin-top: 10px;
  margin-right: 15px;
  float: left;
}

.info_cloud_botton_text {
  width: 90%;
  overflow-wrap: break-word;
  color: #666666;
  display: inline-block;
  white-space: initial;
}

.cloud_main_title {
  display: inline-block;
  margin: 0px 5px;
  padding: 0px 15px;
  overflow-wrap: break-word;
  word-break: normal;
  width: 486px;
  height: 26px;
  font-size: 22px;
  font-weight: bold;
  color: #00d265;
  line-height: 26px;
}

.main_block_div {
  display: inline-block;
  margin: 0px 10px;
  padding: 5px 15px;
  overflow-wrap: break-word;
  word-break: normal;
  width: 486px;
  height: auto;
}

.main_block_img {
  width: 486px;
  height: 300px;
  display: inline-block;
  margin: 0px 10px;
  padding: 0px 15px;
  border: 0px;
}

.main_cloud_context {
  width: 1026px;
  flex-direction: row;
  align-items: center;
  display: contents;
}
.main_cloud_context span {
  width: 50%;
  height: 300px;
  display: inline-block;
  margin-left: 1px;
}
.main_cloud_context img {
  width: 521px;
  height: 300px;
  display: inline-block;
  border: 0px;
}

.title_cloud_context {
  height: 60px;
  margin: 10px 0px;
}

.title_cloud_name {
  height: 48px;
  font-size: 40px;
  font-weight: bold;
  width: 70%;
  display: inline-block;
  color: #333333;
  line-height: 48px;
  text-align: left;
  padding-left: 10%;
}

.green {
  background-color: #00d265;
  height: 16px;
  width: 16px;
  display: inline-block;
}
.gray {
  background-color: #d8d8d8;
  height: 16px;
  width: 16px;
  display: inline-block;
  margin-left: 10px;
}
</style>


// WEBPACK FOOTER //
// src/view/center_cloud.vue